import { toast } from "sonner";

const DEFAULT_CONFIRM_LABEL = "Yes";
const DEFAULT_CANCEL_LABEL = "Cancel";
/** Keep confirm toast open until user clicks (5 min max to avoid Infinity issues). */
const CONFIRM_DURATION = 5 * 60 * 1000;

export interface ConfirmToastOptions {
  confirmLabel?: string;
  cancelLabel?: string;
  /** Use for destructive actions (e.g. delete). */
  variant?: "default" | "destructive";
}

/**
 * Show a Sonner toast with Yes/Cancel buttons and return a promise that resolves
 * to true when the user clicks confirm, false when they click cancel.
 */
export function confirmToast(
  message: string,
  options: ConfirmToastOptions = {}
): Promise<boolean> {
  const {
    confirmLabel = DEFAULT_CONFIRM_LABEL,
    cancelLabel = DEFAULT_CANCEL_LABEL,
    variant = "default",
  } = options;

  return new Promise<boolean>((resolve) => {
    let toastId: string | number;
    const resolveAndClose = (value: boolean) => {
      resolve(value);
      toast.dismiss(toastId);
    };

    const opts = {
      duration: CONFIRM_DURATION,
      action: {
        label: confirmLabel,
        onClick: () => resolveAndClose(true),
      },
      cancel: {
        label: cancelLabel,
        onClick: () => resolveAndClose(false),
      },
    };

    toastId =
      variant === "destructive"
        ? toast.error(message, opts)
        : toast(message, opts);
  });
}
